<div
  class="row section clinical-feedback-section mt-3"
  [formGroupName]="formControlName"
>
  <div class="section-container">
    <div class="row section-row">
      <div class="col section-col">
        <h5 class="section-heading">Contact Details</h5>
        <p>
          Response to the feedback will be sent to the following. Please add any
          additional contacts to the list below:
        </p>
      </div>
    </div>
    <app-contact-person
      [formElementModel]="formElementModels['userAddingFeedback']"
      [parentFormGroup]="formGroup"
    ></app-contact-person>
    <ng-container *ngIf="showConfirmedSeriousIncidentFields">
      <div class="row section-row">
        <div class="col-12 section-col">
          <h6 class="subsection-heading">
            {{ isRegionUki ? contactSectionLabelUki : contactSectionLabelAnz }}
          </h6>
        </div>
      </div>
      <div class="other-contacts-row">
        <app-contact-person
          [formElementModel]="formElementModels['SIOwnerContact']"
          [parentFormGroup]="SIOwnerContactGroup"
        ></app-contact-person>
      </div>
      <div class="row section-row">
        <div class="col-12 section-col">
          <h6 class="subsection-heading">Patient Safety Lead</h6>
        </div>
      </div>
      <div class="other-contacts-row">
        <app-contact-person
          [formElementModel]="formElementModels['patientSafetyLead']"
          [parentFormGroup]="patientSafetyLeadGroup"
        ></app-contact-person>
      </div>
    </ng-container>
    <div class="row section-row">
      <div class="col-12 section-col">
        <h6 class="subsection-heading">Others to contact</h6>
      </div>
    </div>
    <div class="other-contacts">
      <div
        *ngFor="let person of otherContactsControls; let i = index"
        class="other-contacts-row"
      >
        <app-contact-person
          [formElementModel]="formElementModels['otherContacts']"
          [parentFormGroup]="person"
          [disableLabel]="i > 0"
        >
          <button
            *ngIf="otherContactsControls.length > 1"
            class="d-inline justify-content-center align-items-center mt-n2"
            type="button"
            (click)="deleteOtherContact(i)"
            id="deleteOtherContact{{ i }}"
            mat-icon-button
            matTooltip="Delete contact"
            matTooltipShowDelay="1000"
            matTooltipPosition="right"
            tabIndex="-1"
          >
            <fa-icon class="primary" [icon]="['fas', 'trash']"></fa-icon>
          </button>
        </app-contact-person>
      </div>
      <button
        class="d-inline justify-content-center align-items-center mt-n2"
        type="button"
        (click)="addOtherContact()"
        id="addOtherContact"
        mat-icon-button
        matTooltip="Add contact"
        matTooltipShowDelay="1000"
        matTooltipPosition="right"
        tabIndex="0"
      >
        <mat-icon class="mat-evericon">add</mat-icon>
      </button>
    </div>
  </div>
</div>
